/* Cross-sell du cart drawer : ajout au panier depuis les boutons [data-cross-sell-add].
   Extrait de layout/theme.liquid le 2026-09-06 (audit T4). */
(function() {
        var plusIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
        var checkIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg>';
        var spinner = '<span class="cross-sell-spinner"></span>';

        document.addEventListener('click', function(e) {
          var btn = e.target.closest('[data-cross-sell-add]');
          if (!btn) return;

          e.preventDefault();
          e.stopPropagation();

          if (btn.dataset.adding === 'true') return;

          var variantId = btn.dataset.variantId;
          btn.dataset.adding = 'true';
          btn.innerHTML = spinner;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(function(res) {
            if (!res.ok) throw new Error('Erreur ajout');
            return res.json();
          })
          .then(function() {
            btn.innerHTML = checkIcon;
            setTimeout(function() {
              document.dispatchEvent(new CustomEvent('theme:update:cart'));
            }, 300);
          })
          .catch(function() {
            btn.dataset.adding = 'false';
            btn.innerHTML = plusIcon;
          });
        }, true);
      })();

/* Points de défilement des suggestions (2026-09-11).
   Un point par position de défilement (4 tuiles dont 2 visibles = 3 positions), le
   point actif suit le scroll, un clic sur un point fait défiler jusqu'à la position.
   Masqués quand toutes les tuiles tiennent à l'écran. Le tiroir est re-rendu à
   chaque mise à jour du panier : un MutationObserver branche les nouvelles rangées.
   Un seul écouteur resize et un seul ResizeObserver pour toutes les rangées ; les
   rangées retirées du DOM sont oubliées au scan suivant (audit A10, 2026-09-26). */
(function () {
  var rows = []; /* { row, schedule } des rangées branchées */
  var resizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          for (var i = 0; i < rows.length; i++) if (rows[i].row === entry.target) rows[i].schedule();
        });
      })
    : null;
  window.addEventListener('resize', function () {
    rows.forEach(function (r) { r.schedule(); });
  });

  function setup(row) {
    if (row.dataset.ezDots) return;
    var wrap = row.parentElement;
    var host = wrap && wrap.querySelector('.ez-xs-dots');
    if (!host) return;
    row.dataset.ezDots = '1';
    var pill = document.createElement('span');
    pill.className = 'ez-xs-dots__pill';
    host.appendChild(pill);

    function step() {
      var items = row.querySelectorAll('.ez-xs-item');
      if (items.length < 2) return 0;
      return items[1].offsetLeft - items[0].offsetLeft;
    }
    function pages() {
      var s = step();
      var max = row.scrollWidth - row.clientWidth;
      if (!s || max <= 4) return 1;
      return Math.ceil(max / s - 0.05) + 1;
    }
    function build() {
      var n = pages();
      host.hidden = n < 2;
      if (pill.children.length === n) return;
      pill.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Suggestions ' + (i + 1) + ' sur ' + n);
        (function (k) {
          b.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var max = row.scrollWidth - row.clientWidth;
            row.scrollTo({ left: Math.min(k * step(), max), behavior: 'smooth' });
          });
        })(i);
        pill.appendChild(b);
      }
    }
    function update() {
      build();
      var n = pill.children.length;
      if (n < 2) return;
      var max = row.scrollWidth - row.clientWidth;
      var idx = row.scrollLeft >= max - 4 ? n - 1 : Math.round(row.scrollLeft / (step() || 1));
      idx = Math.max(0, Math.min(n - 1, idx));
      for (var k = 0; k < n; k++) pill.children[k].classList.toggle('on', k === idx);
    }
    var raf = 0;
    function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); }
    row.addEventListener('scroll', schedule, { passive: true });
    rows.push({ row: row, schedule: schedule });
    /* Le tiroir s'ouvre après le rendu : on recalcule quand la rangée devient visible */
    if (resizeObserver) resizeObserver.observe(row);
    update();
  }
  function scan() {
    rows = rows.filter(function (r) {
      if (r.row.isConnected) return true;
      if (resizeObserver) resizeObserver.unobserve(r.row);
      return false;
    });
    document.querySelectorAll('.cart-cross-sell .ez-xs-row').forEach(setup);
  }
  var scanRaf = 0;
  function scheduleScan() { if (!scanRaf) scanRaf = requestAnimationFrame(function () { scanRaf = 0; scan(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
})();

